<template>
  <div
    class="modal fade"
    tabindex="-1"
    ref="dialogModal"
    role="dialog"
    aria-hidden="true"
    data-backdrop="static"
  >
    <div class="modal-dialog" :class="size" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title h5">{{ modalTitle }}</h5>
          <button
            type="button"
            class="close btn btn-secondary"
            aria-label="Close"
            @click="closeModal"
          >
            <i class="fas fa-times"></i>
          </button>
        </div>
        <form
          class="needs-validation"
          data-toggle="validator"
          @submit.prevent="handleSubmit"
          ref="officialForm"
        >
          <div class="modal-body mh-100 position-relative" :style="[bodyStyle]">
            <!-- 根據 currentPage 顯示單一項目 -->

            <div v-if="currentItem">
              <div class="form-group mb-2">
                <p
                  class="fw-bold alert alert-success align-items-center my-2 fs-6"
                  role="alert"
                >
                  基本資訊
                </p>

                <div class="row g-2 align-content-center my-2">
                  <div class="col-auto">
                    <label class="col-form-label">中華民國</label>
                  </div>
                  <div class="col-1">
                    <input
                      type="text"
                      class="form-control"
                      v-model="currentItem.issueYear"
                    />
                  </div>
                  <div class="col-auto">
                    <label class="col-form-label">年</label>
                  </div>
                  <div class="col-1">
                    <input
                      type="text"
                      class="form-control"
                      v-model="currentItem.issueMonth"
                    />
                  </div>
                  <div class="col-auto">
                    <label class="col-form-label">月</label>
                  </div>
                  <div class="col-1">
                    <input
                      type="text"
                      class="form-control"
                      v-model="currentItem.issueDay"
                    />
                  </div>
                  <div class="col-auto">
                    <label class="col-form-label">日</label>
                  </div>
                  <div class="col-2">
                    <input
                      type="text"
                      class="form-control"
                      v-model="currentItem.issuingUnit"
                    />
                  </div>
                  <div class="col-auto">
                    <label class="col-form-label">字第</label>
                  </div>
                  <div class="col-2">
                    <input
                      type="text"
                      class="form-control"
                      v-model="currentItem.issueNumber"
                      disabled
                    />
                  </div>
                  <div class="col-auto">
                    <label class="col-form-label">號</label>
                  </div>
                </div>
                <div class="row justify-content-between">
                  <div class="col-md-6 form-group row align-items-center my-2">
                    <label class="form-label col-md-6">
                      姓名 <br />
                      法人或非法人團體名稱
                    </label>
                    <div class="col-md-6">
                      <input
                        class="form-control"
                        v-model="currentItem.name"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-md-6 form-group row align-items-center my-2">
                    <label class="form-label col-md-3"> 性別 </label>
                    <div class="col-md-9">
                      <select
                        class="form-select"
                        name=""
                        id=""
                        v-model="currentItem.gender"
                        required
                      >
                        <option value="男性">男性</option>
                        <option value="女性">女性</option>
                      </select>
                      <!-- <input class="form-control" v-model="currentItem.gender" required/> -->
                    </div>
                  </div>

                  <div class="col-md-6 form-group row align-items-center my-2">
                    <label class="form-label col-md-6">
                      管理人或代表人之姓名
                    </label>
                    <div class="col-md-6">
                      <input
                        class="form-control"
                        v-model="currentItem.managerName"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-md-6 form-group row align-items-center my-2">
                    <label class="form-label col-md-3"> 出生日 </label>
                    <div class="col-md-9">
                      <input
                        class="form-control"
                        v-model="currentItem.birthday"
                        placeholder="民國OOO年OO月OO日：089/01/01"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-md-6 form-group row align-items-center my-2">
                    <label class="form-label col-md-6"> 身分證統一號碼 </label>
                    <div class="col-md-6">
                      <input
                        class="form-control"
                        v-model="currentItem.nationalId"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-md-6 form-group row align-items-center my-2">
                    <label class="form-label col-md-5">
                      住(居)所 <br />
                      事務所或營業所
                    </label>
                    <div class="col-md-7">
                      <input
                        class="form-control"
                        v-model="currentItem.address"
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group mb-2">
                <p
                  class="fw-bold alert alert-success align-items-center my-2 fs-6"
                  role="alert"
                >
                  違規事實、時間、地點
                </p>

                <div class="row my-2 g-2">
                  <div class="col-md-2">
                    <label class="col-form-label">違反事實</label>
                  </div>
                  <div class="col-md-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="currentItem.violationDescription"
                      required
                    />
                  </div>
                </div>
                <div class="row g-2 align-content-center my-2">
                  <!-- <div class="row"> -->
                  <div class="col-2">
                    <label class="col-form-label">違反時間</label>
                  </div>
                  <div class="col-auto">
                    <label class="col-form-label">中華民國</label>
                  </div>
                  <div class="col-1">
                    <input
                      type="text"
                      class="form-control"
                      v-model="currentItem.violationYear"
                      required
                    />
                  </div>
                  <div class="col-auto">
                    <label class="col-form-label">年</label>
                  </div>
                  <div class="col-1">
                    <input
                      type="text"
                      class="form-control"
                      v-model="currentItem.violationMonth"
                      required
                    />
                  </div>
                  <div class="col-auto">
                    <label class="col-form-label">月</label>
                  </div>
                  <div class="col-1">
                    <input
                      type="text"
                      class="form-control"
                      v-model="currentItem.violationDay"
                      required
                    />
                  </div>
                  <div class="col-auto">
                    <label class="col-form-label">日</label>
                  </div>
                  <div class="col-1">
                    <input
                      type="text"
                      class="form-control"
                      v-model="currentItem.violationHour"
                      required
                    />
                  </div>
                  <div class="col-auto">
                    <label class="col-form-label">時</label>
                  </div>
                  <div class="col-1">
                    <input
                      type="text"
                      class="form-control"
                      v-model="currentItem.violationMinute"
                      required
                    />
                  </div>
                  <div class="col-auto">
                    <label class="col-form-label">分</label>
                  </div>
                  <!-- </div> -->
                </div>

                <div class="row mb-3 mt-3">
                  <div class="col-md-2">
                    <label class="form-label">違反地點</label>
                  </div>
                  <div class="col-md-10">
                    <input
                      class="form-control"
                      v-model="currentItem.violationPlace"
                      required
                    />
                  </div>
                </div>
              </div>

              <div class="form-group mb-2">
                <p
                  class="fw-bold alert alert-success align-items-center my-2 fs-6"
                  role="alert"
                >
                  涉嫌違反法令
                </p>

                <div class="row my-2 g-2">
                  <div class="col-md-3">
                    <label class="col-form-label">發展觀光條例 </label>
                  </div>
                  <div class="col-md-auto">
                    <label class="col-form-label">第</label>
                  </div>
                  <div class="col-md-1">
                    <input
                      type="text"
                      class="form-control"
                      v-model="currentItem.tourismLaw.articles"
                    />
                  </div>
                  <div class="col-md-auto">
                    <label class="col-form-label">條第</label>
                  </div>
                  <div class="col-md-1">
                    <input
                      type="text"
                      class="form-control"
                      v-model="currentItem.tourismLaw.paragraph"
                    />
                  </div>
                  <div class="col-md-auto">
                    <label class="col-form-label">項。</label>
                  </div>
                </div>

                <div class="row my-2 g-2">
                  <div class="col-md-3">
                    <label class="col-form-label">風景特定區管理規則</label>
                  </div>
                  <div class="col-md-auto">
                    <label class="col-form-label">第</label>
                  </div>
                  <div class="col-md-1">
                    <input
                      type="text"
                      class="form-control"
                      v-model="currentItem.scenicRule.articles"
                    />
                  </div>
                  <div class="col-md-auto">
                    <label class="col-form-label">條第</label>
                  </div>
                  <div class="col-md-1">
                    <input
                      type="text"
                      class="form-control"
                      v-model="currentItem.scenicRule.paragraph"
                    />
                  </div>
                  <div class="col-md-auto">
                    <label class="col-form-label">項。</label>
                  </div>
                </div>

                <div class="row my-2 g-2">
                  <div class="col-md-3">
                    <label class="col-form-label">水域遊憩區活動管理辦法</label>
                  </div>
                  <div class="col-md-auto">
                    <label class="col-form-label">第</label>
                  </div>
                  <div class="col-md-1">
                    <input
                      type="text"
                      class="form-control"
                      v-model="currentItem.waterActivityLaw.articles"
                    />
                  </div>
                  <div class="col-md-auto">
                    <label class="col-form-label">條第</label>
                  </div>
                  <div class="col-md-1">
                    <input
                      type="text"
                      class="form-control"
                      v-model="currentItem.waterActivityLaw.paragraph"
                    />
                  </div>
                  <div class="col-md-auto">
                    <label class="col-form-label">項。</label>
                  </div>
                </div>
              </div>

              <div class="form-group mb-2">
                <p
                  class="fw-bold alert alert-success align-items-center my-2 fs-6"
                  role="alert"
                >
                  被通知人應依下列事項辦理：
                </p>
                <div class="row gap-2 mb-3">
                  <!-- 主選項 -->
                  <div class="form-check-inline col-md-auto">
                    <label class="form-check-label">一、 </label>
                    <label class="form-check-label" for="stopMain">
                      <input
                        class="form-check-input mt-0"
                        type="checkbox"
                        id="stopMain"
                        v-model="currentItem.stop.main"
                      />
                      立即停止：
                    </label>
                  </div>

                  <div class="form-check col-md-auto">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="stopBehavior"
                      v-model="currentItem.stop.stopBehavior"
                    />
                    <label class="form-check-label" for="stopBehavior"
                      >行為、</label
                    >
                  </div>

                  <div class="form-check col-md-auto">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="stopConstruction"
                      v-model="currentItem.stop.stopConstruction"
                    />
                    <label class="form-check-label" for="stopConstruction"
                      >工程、</label
                    >
                  </div>

                  <div class="form-check col-md-auto">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="stopBusiness"
                      v-model="currentItem.stop.stopBusiness"
                    />
                    <label class="form-check-label" for="stopBusiness"
                      >營業。</label
                    >
                  </div>
                </div>
                <div class="form-check my-2">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="cleanMain"
                    v-model="currentItem.clean.main"
                  />
                  <label class="form-check-label row g-2">
                    <div class="col-form-label col-md-auto">在</div>
                    <div class="col-md-2">
                      <input
                        type="text"
                        class="form-control"
                        v-model="currentItem.clean.day"
                      />
                    </div>
                    <div class="col-md-auto">
                      <label class="col-form-label">日內清理完成。</label>
                    </div>
                  </label>
                </div>
                <div class="form-check my-2">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="rule2"
                    v-model="currentItem.restore.main"
                  />
                  <label class="form-check-label row g-2">
                    <div class="col-form-label col-md-auto">在</div>
                    <div class="col-md-2">
                      <input
                        type="text"
                        class="form-control"
                        v-model="currentItem.restore.day"
                      />
                    </div>
                    <div class="col-md-auto">
                      <label class="col-form-label">日內恢復原狀。</label>
                    </div>
                  </label>
                </div>
                <div class="form-check my-2">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="rule2"
                    v-model="currentItem.other.main"
                  />
                  <label class="form-check-label row g-2">
                    <div class="col-form-label col-md-auto">其他：</div>
                    <div class="col-md-8">
                      <input
                        type="text"
                        class="form-control"
                        v-model="currentItem.other.description"
                      />
                    </div>
                  </label>
                </div>

                <!-- 二 -->
                <div class="mb-2">
                  <!-- <div class="me-2 fw-bold">二、</div> -->
                  <div class="row">
                    <label class="mb-1 col-form-label">
                      二、台端涉及違反「發展觀光條例」規定事項，特此通知：
                    </label>
                  </div>
                  <div>
                    <div class="form-check my-2">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="rule1"
                        v-model="currentItem.rule1"
                      />
                      <label class="form-check-label col-md-4" for="rule1">
                        未依前項辦理者，即依法處分。
                      </label>
                    </div>

                    <div class="form-check my-2">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="rule2"
                        v-model="currentItem.rule2.main"
                      />
                      <label class="form-check-label g-2 row" for="rule2">
                        <div class="col-md-auto">
                          <label class="col-form-label"
                            >並依發展觀光條例第</label
                          >
                        </div>
                        <div class="col-md-1">
                          <input
                            type="text"
                            class="form-control"
                            v-model="currentItem.rule2.articles"
                          />
                        </div>
                        <div class="col-md-auto">
                          <label class="col-form-label">條第</label>
                        </div>
                        <div class="col-md-1">
                          <input
                            type="text"
                            class="form-control"
                            v-model="currentItem.rule2.section"
                          />
                        </div>
                        <div class="col-md-auto">
                          <label class="col-form-label">項。</label>
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group mb-2">
                <p
                  class="fw-bold alert alert-success align-items-center my-2 fs-6"
                  role="alert"
                >
                  通知送達方式
                </p>

                <div class="form-check my-2">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="currentItem.delivery.registered"
                  />
                  <label class="form-check-label">雙掛號寄出 </label>
                </div>

                <div class="form-check my-2">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="currentItem.delivery.signIn"
                  />
                  <label class="form-check-label">現場簽收</label>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-center">
            <!-- <div class="modal-footer justify-content-between"> -->

            <div
              v-if="isMutiple"
              class="d-flex justify-content-between align-items-center footer-controls"
            >
              <button
                type="button"
                class="btn btn-primary same-width"
                @click="prevPage"
                :disabled="currentPage === 1"
              >
                上一頁
              </button>
              <span class="mx-3">{{ currentPage }} / {{ allPage }}</span>
              <button
                type="submit"
                class="btn same-width"
                :class="currentPage === allPage ? 'btn-warning' : 'btn-primary'"
              >
                {{ currentPage === allPage ? "確認輸出PDF" : "下一頁" }}
              </button>
            </div>
            <div v-if="!isMutiple">
              <button type="submit" class="btn btn-primary">
                確認輸出為 PDF
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Utils from "../../utils/utils";
import CONST from "../../utils/const";
import { my } from "resource";
import { printOfficialViolationNotice } from "@/utils/exportViolationPDF";
import {
  getSerialNumber,
  addSerialNumber,
} from "../../api/eastCoastDataApi/ElkQuery/VehicleElk";

export default {
  data() {
    return {
      isActive: true,
      bodyStyle: "",
      isMutiple: true,
      allPage: 0,
      currentPage: 1,
      form: [],
      loading: false,
      postSerialNumber: [],
      accountName: "",
    };
  },
  props: ["modalTitle", "mode", "modalSize", "violationData"],
  name: "dialog-modal",
  computed: {
    size() {
      return `modal-${this.modalSize}`;
    },
    currentItemIndex() {
      return this.currentPage - 1;
    },
    currentItem() {
      return this.form[this.currentItemIndex];
    },
  },
  methods: {
    openModal() {
      $(this.$refs.dialogModal).modal("show");
    },
    closeModal() {
      $(this.$refs.dialogModal).modal("hide");
    },
    nextPage() {
      if (this.currentPage < this.allPage) {
        this.currentPage++;
      } else {
        this.getExportViolationPDF();
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    getElkImgUrl(item) {
      return Utils.transElkImgByNginx(item.streamUrl);
    },

   async getExportViolationPDF() {
      try {
        await printOfficialViolationNotice(this.form);
        // 成功列印後送出流水號記錄 & emit selectedItems
        this.addSerialNumber(this.postSerialNumber);
        this.$emit("clearSelectedItems");
        this.closeModal();
        // console.log("initSelectedItems");
      } catch (error) {
        console.error("printBasicViolationNotice", error);
      }
    },

    handleSubmit() {
      //required 項目全數填寫完才能送出
      if (this.currentPage !== this.allPage) {
        this.nextPage();
      } else {
        const form = this.$refs.officialForm;
        if (form.checkValidity()) {
          this.getExportViolationPDF();
        }
      }
    },

    async getSerialNumber(data) {
      let condition = {
        year: moment(data[0].dt).format("YYYY"),
        month: moment(data[0].dt).format("MM"),
      };
      let response = await getSerialNumber(condition);

      return response.data.count;
    },

    async addSerialNumber(data) {
      console.log("addSerialNumber", data);
      if (data.length !== 0) {
        console.log("data.length !== 0");
        await addSerialNumber(data);
      }
    },

    async initFormData(data) {
      //將傳入的 data 物件陣列，轉換為 form 的初始值
      let serialNumber = await this.getSerialNumber(data);
      this.postSerialNumber = [];
      this.form = []; // 先清空表單陣列
      let currentSerial = serialNumber; // 設定當前的序號為傳入的序號
      data.forEach((item) => {
        if (item.serialNumber === undefined || item.serialNumber === null) {
          currentSerial += 1;
          this.postSerialNumber.push({
            eventId: item.eventID,
            serialNumber: currentSerial,
            printAccountName: this.accountName,
            printTime: moment().format(),
          });
        } else {
          currentSerial = item.serialNumber; // 如果已有流水號，則使用該號碼
        }

        const formItem = {
          issueNumber: `${Utils.convertToTaiwanYear(item.dt)}${moment(
            item.dt
          ).format("MM")}${Utils.formatThreeDigits(currentSerial)}`,
          area: item.areaName,
          // name:item.name,
          violationPlace: `${item.areaName}${item.publicPlaceName}`,
          licensePlate: item.licensePlate,
          dt: `${Utils.convertToTaiwanYear(item.dt)}${moment(item.dt).format(
            "-MM-DD HH:mm"
          )}`,
          issueYear: Utils.convertToTaiwanYear(item.dt),
          issueMonth: moment(item.dt).format("MM"),
          issueDay: moment(item.dt).format("DD"),

          violationYear: Utils.convertToTaiwanYear(item.dt),
          violationMonth: moment(item.dt).format("MM"),
          violationDay: moment(item.dt).format("DD"),
          violationHour: moment(item.dt).format("HH"),
          violationMinute: moment(item.dt).format("mm"),

          tourismLaw: {
            articles: "",
            paragraph: "",
          },
          scenicRule: {
            articles: "",
            paragraph: "",
          },
          waterActivityLaw: {
            articles: "",
            paragraph: "",
          },
          stop: {
            main: false,
            stopBehavior: false,
            stopConstruction: false,
            stopBusiness: false,
          },
          clean: {
            main: false,
            day: "",
          },
          restore: {
            main: false,
            day: "",
          },
          other: {
            main: false,
            description: "",
          },
          rule1: false,
          rule2: {
            main: false,
            articles: "",
            section: "",
          },
          delivery: {
            registered: false,
            signIn: false,
          },
        };
        this.form.push(formItem);
      });
      console.log("this.form", this.form);
      console.log("postSerialNumber", this.postSerialNumber);

    },
  },
  watch: {
    violationData: {
      handler(newVal) {
        if (newVal === null || newVal.length === 0) {
          return;
        }
        // console.log("watch Official-violationData", newVal);
        this.allPage = newVal.length;
        this.isMutiple = this.allPage > 1;
        this.initFormData(newVal);
      },
    },
  },
  mounted() {
    $(this.$refs.dialogModal).on("shown.bs.modal", () => {
      this.$emit("dialog-opend");
    });
    $(this.$refs.dialogModal).on("hidden.bs.modal", () => {
      this.$emit("dialog-close");
    });

    my.info().then(a => {
      this.accountName = a.body.name;
    });
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.footer-controls {
  /* width: 100%; */
  max-width: 400px;
}

.same-width {
  /* width: 100%; */
  min-width: 100px;
}

.form-label,
.col-form-label,
.form-check-label,
input.form-control {
  font-size: 1rem; /* 或根據需要設為 1.1rem、1.2rem 等 */
}

/* 自訂 checkbox 大小與對齊方式 */
.form-check-input {
  width: 1.2em;
  height: 1.2em;
  margin-top: 0.25em;
  vertical-align: middle;
}

/* 統一 checkbox 與 label 的間距與對齊 */
.form-check {
  display: flex;
  align-items: center;
  gap: 0.4em;
  font-size: 1rem;
}

/* optional: 增加行距讓表單整體更舒服 */
.form-group {
  line-height: 1.6;
}

label {
  font-weight: 400;
}

.modal-body {
  overflow: visible;
}
</style>
